import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StringHelper } from 'src/app/helpers/string-helper';
import { Project } from 'src/app/model/project/project';
import { SetSubProjectOnHoldControllerRequestService } from './set-sub-project-on-hold-request-controller.service';
import { SnackService } from 'src/app/services/snack.service';
import { SubProject } from 'src/app/model/project/sub-project';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';

@Component({
  selector: 'ip-board-on-hold-dialog',
  templateUrl: './ip-board-on-hold-dialog.component.html',
  styleUrls: ['./ip-board-on-hold-dialog.component.scss']
})
export class IPBoardOnHoldDialogComponent implements OnInit {
  @Input()
  project: Project;
  @Input()
  subProject: SubProject;
  @Output()
  close = new EventEmitter<boolean>();

  onHoldReason: string;

  submitting: boolean = false;

  constructor(
    private setSubProjectOnHoldControllerRequestService: SetSubProjectOnHoldControllerRequestService,
    private projectDisplayObservableService: ProjectDisplayObservableService,
    private snackService: SnackService
  ) {}

  ngOnInit(): void {
    this.onHoldReason = this.subProject.onHoldReason;
  }

  onHoldReasonChanged(value: string): void {
    this.onHoldReason = value;
  }

  closeDialog(): void {
    this.close.emit(false);
  }

  async confirmOnHold(): Promise<void> {
    if (StringHelper.isEmptyOrWhiteSpace(this.onHoldReason)) {
      this.snackService.showError('Gelieve een reden in te vullen');
      return;
    }
    this.submitting = true;
    try {
      const loggedAction = await this.setSubProjectOnHoldControllerRequestService.setSubProjectOnHold(
        this.subProject.id,
        this.onHoldReason
      );
      this.subProject.onHold = true;
      this.subProject.onHoldReason = this.onHoldReason;
      this.subProject.putOnHold = loggedAction;
      this.subProject.onHoldHandling = null;
      this.subProject.onHoldHandled = null;
      this.subProject.approved = false;
      this.subProject.approvedRegistration = null;
      this.subProject.tourItem = null;
      this.projectDisplayObservableService
        .getTourUnassignedAsSideEffectSubscribable()
        .next({
          subProjectId: this.subProject.id
        });
      this.projectDisplayObservableService
        .getTourConfigurationChangedSubscribable()
        .next({
          subProjectId: this.subProject.id,
          assignedToTour: false,
          placer: null,
          date: null
        });
      this.close.emit(true);
    } finally {
      this.submitting = false;
    }
  }
}
